import { Box, Heading, Modal, Text } from '@zillow/constellation-10';

import ApplicationsWrapper from '../../ApplicationsWrapper';

const ApplicationsIntroModal = ({ onClose }: { onClose: () => void }) => {
  return (
    <Modal
      open={true}
      onOpenChange={(open) => !open && onClose()}
      header={<Heading level={3}>Zillow applications</Heading>}
      size={{ base: 'fullScreen', md: 'md' }}
      body={
        <ApplicationsWrapper isIntroModal={true}>
          <Box css={{ paddingBottom: '800' }}>
            <Heading level={5} css={{ paddingBottom: '400' }}>
              Why renters love using Zillow applications
            </Heading>
            <Text>
              They can save time and money by paying a single application fee to apply to multiple properties for 30
              days.
            </Text>
          </Box>
        </ApplicationsWrapper>
      }
    />
  );
};

export default ApplicationsIntroModal;
